var insert = require('insert-css');

var normalize = require('./normalize');

insert(normalize);